import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { optimistActions, useOptimistReportDispatch } from "./state";
import { COLLAPSE_DURATION } from "./usePanelCollapse";
export default function useScrollToAccount() {
    const location = useLocation();
    const lastHash = useRef("");
    const dispatch = useOptimistReportDispatch();
    // listen to location change using useEffect with location as dependency
    // https://jasonwatmore.com/react-router-v6-listen-to-location-route-change-without-history-listen
    useEffect(() => {
        if (!location.hash) {
            return;
        }
        lastHash.current = location.hash.slice(1); // safe hash for further use after navigation
        const [creditManager, creditAccount] = lastHash.current
            .toLowerCase()
            .split("_");
        dispatch(optimistActions.togglePanelCollapse({
            creditAccount,
            creditManager,
            opened: true,
        }));
        setTimeout(() => {
            if (lastHash.current && document.getElementById(lastHash.current)) {
                document
                    .getElementById(lastHash.current)
                    ?.scrollIntoView({ behavior: "smooth", block: "start" });
                lastHash.current = "";
            }
        }, COLLAPSE_DURATION + 50);
    }, [location, dispatch]);
}
